/** @type {import('@maskito/core').MaskitoOptions} */
export const phoneMaskSpaced = {
  mask: [
    '+',
    '7',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/
  ]
}

/** @type {import('@maskito/core').MaskitoOptions} */
export const phoneMaskParentheses = {
  mask: [
    '+',
    '7',
    ' ',
    '(',
    /\d/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/
  ]
}
